import en_us from './en_us';
import sv_se from './sv_se';

export default {
    en_us,
    sv_se,
}